import React from "react";
import styled from "@emotion/styled";

type SquareProps = {
  children: React.ReactElement;
};

const SquareWrapper = styled.div`
  height: 0px;
  padding-bottom: 100%;
  position: relative;

  > * {
    /* Don't influence parent's height */
    position: absolute;
    top: 0;
    left: 0;

    /* Size fully */
    width: 100%;
    height: 100%;

    /* Center image and crop overflowing bits */
    object-fit: cover;
    object-position: center;
  }
`;

export const Square = ({ children }: SquareProps) => {
  return <SquareWrapper>{children}</SquareWrapper>;
};
